'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$17() {
  this.awD = null;
  this.awE = false;
}
export { $c_Lpresto_AgentView$$anon$17 as $c_Lpresto_AgentView$$anon$17 };
$p = $c_Lpresto_AgentView$$anon$17.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$17;
/** @constructor */
function $h_Lpresto_AgentView$$anon$17() {
}
export { $h_Lpresto_AgentView$$anon$17 as $h_Lpresto_AgentView$$anon$17 };
$h_Lpresto_AgentView$$anon$17.prototype = $p;
$p.P = (function() {
  if ((!this.awE)) {
    this.awD = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.awE = true;
  }
  return this.awD;
});
var $d_Lpresto_AgentView$$anon$17 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$17, "presto.AgentView$$anon$17", ({
  DF: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$17 as $d_Lpresto_AgentView$$anon$17 };
//# sourceMappingURL=presto.-Agent-View$$anon$17.js.map
